/* eslint-disable camelcase */
// eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {
    useCallback, useContext
} from 'react';
import _ from 'lodash';
import appConfig from 'app-config';
import { useTranslator} from '@jutro/locale';
import PropTypes from 'prop-types';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

import metadata from './VehiclesListPopupComponent.metadata.json5';
import styles from './VehiclesListPopupComponent.module.scss';

function VehiclesListPopupComponent(props) {
    const translator = useTranslator();

    const{
        paModelVM,
        onVehicleAdd,
        onVehicleEdit,
        onVehicleRemove,
        onVehicleReplace,
        onCancel,
        viewModelService,
        submissionVM
    }=props
    const isGpa = appConfig.portalCode === 'GPA';
    const bodyTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('BodyType');
    const vehiclesList = _.get(paModelVM, 'coverables.vehicles.children', [])
    const vehicles = _.get(paModelVM, 'coverables.vehicles.value', [])
       //new product
    const isModernProduct =_.get(submissionVM, "isModernProduct_Ext.value",false)

    const getTypeKeyDescription = useCallback((typeKeyName) => {
        return translator({
            id: typeKeyName,
            defaultMessage: typeKeyName
        });
    }, [translator]);

    const generateOverrides = () => {
        const overrides = vehicles.map((item, index) => {
            return {
                [`yearCell${index}`]: {
                    className: `cell ${_.get(item, 'error', false) ? 'error-help-text font-weight-bold ' : ''}`
                },
                [`yearErrorAlertIcon${index}`]: {
                    visible: _.get(item, 'error', false)
                },
                [`year${index}`]: {
                    content: item.year
                },
                [`make${index}`]: {
                    content: item.make
                },
                [`model${index}`]: {
                    content: item.model
                },
                [`bodyType${index}`]: {
                    visible:!isModernProduct,
                    content: item.bodyType_ML ? getTypeKeyDescription(bodyTypelist.getCode(item.bodyType_ML).name) : null
                },
                  [`bodyTypeCellHeader${index}`]: {
                      visible:!isModernProduct,
                  },
                     [`bodyTypeCell${index}`]: {
                      visible:!isModernProduct,
                  },                      
                [`trim${index}`]: {
                    content: item.trim_ML
                },
                [`vin${index}`]: {
                    content: item.vin
                },
                [`replaceVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                },
                [`editVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                },
                [`removeVehicle${index}`]: {
                    'aria-labelledby': `year${index} make${index} model${index} bodyType${index} trim${index} vin${index}`
                }
            };
        });

        return Object.assign({}, ...overrides);
    };

    const overrides ={
        mainContent: {
            className: isGpa ? styles['ml-vehicles-popup'] : styles['ml-vehicles-popup-amp']
        },
        vehicleContentContainer: {
            visible: vehiclesList.length > 0 && !(vehiclesList.length === 1 && vehiclesList[0].value.namedNonOwner_ML === true)
        },
        vehicleIterable: {
            data: vehiclesList
        },
        bodyTypeCellHeader:{
          visible:!isModernProduct,          
        },
        bodyTypeCell:{
            visible:!isModernProduct, 
        },
        ...generateOverrides()
    }
    
    const resolvers={
        resolveClassNameMap: styles,
        resolveCallbackMap:{
            onVehicleEdit: (callbackProps)=>{
                onVehicleEdit(vehiclesList[callbackProps.index],onCancel)
            },
            onVehicleRemove:(callbackProps)=>{
                onVehicleRemove(vehiclesList[callbackProps.index],onCancel)
            },
            onVehicleReplace:(callbackProps)=>{
                onVehicleReplace(vehiclesList[callbackProps.index],onCancel)
            },
            onVehicleAdd:()=>{
                onVehicleAdd(onCancel)
            }
        }
    }

    return(
        <ViewModelForm
            uiProps={metadata.componentContent}
            overrideProps={overrides}
            model={paModelVM}
            componentMap={resolvers.resolveComponentMap}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}
VehiclesListPopupComponent.propTypes={
    id: PropTypes.string,
    paModelVM:PropTypes.shape({}).isRequired
};

VehiclesListPopupComponent.defaultProps = {
    id: undefined,
};

export default VehiclesListPopupComponent;